// LoadingLogin.jsx
import React from 'react';
import { Lock, Shield, RefreshCw } from 'lucide-react';

const LoadingLogin = () => {
  return (
    <div className="login-loading-overlay">
      <div className="login-loading-container">
        <div className="secure-login-animation">
          <div className="secure-login-circle"></div>
          <div className="secure-login-glow"></div>
          <Lock className="lock-icon" size={28} />
          <div className="secure-particles">
            <span className="particle"></span>
            <span className="particle"></span>
            <span className="particle"></span>
            <span className="particle"></span>
            <span className="particle"></span>
            <span className="particle"></span>
          </div>
        </div>
        <p className="login-loading-text">Securely signing you in...</p>
      </div>

      <style jsx>{`
        .login-loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(17, 24, 39, 0.9);
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        
        .login-loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: rgba(31, 41, 55, 0.7);
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          border: 1px solid rgba(79, 70, 229, 0.2);
          position: relative;
          overflow: hidden;
        }
        
        .secure-login-animation {
          position: relative;
          width: 80px;
          height: 80px;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .secure-login-circle {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 3px solid transparent;
          border-top-color: #4F46E5;
          border-right-color: #4F46E5;
          animation: spin 2s linear infinite;
        }
        
        .secure-login-circle:before {
          content: '';
          position: absolute;
          top: 5px;
          left: 5px;
          right: 5px;
          bottom: 5px;
          border-radius: 50%;
          border: 3px solid transparent;
          border-top-color: #818CF8;
          animation: spin 3s linear infinite;
        }
        
        .secure-login-glow {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(99, 102, 241, 0.4) 0%, rgba(99, 102, 241, 0) 70%);
          animation: pulse 2s ease-in-out infinite;
        }
        
        .lock-icon {
          position: relative;
          color: white;
          filter: drop-shadow(0 0 10px rgba(99, 102, 241, 0.8));
          animation: pulse-icon 2s infinite;
        }
        
        .secure-particles .particle {
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #818CF8;
          opacity: 0;
        }
        
        .secure-particles .particle:nth-child(1) {
          top: 20%;
          left: 0;
          animation: particle-animation 2s ease-in-out infinite 0.1s;
        }
        
        .secure-particles .particle:nth-child(2) {
          top: 60%;
          left: 5%;
          animation: particle-animation 2s ease-in-out infinite 0.3s;
        }
        
        .secure-particles .particle:nth-child(3) {
          top: 30%;
          right: 5%;
          animation: particle-animation 2s ease-in-out infinite 0.5s;
        }
        
        .secure-particles .particle:nth-child(4) {
          bottom: 10%;
          left: 45%;
          animation: particle-animation 2s ease-in-out infinite 0.2s;
        }
        
        .secure-particles .particle:nth-child(5) {
          top: 10%;
          right: 30%;
          animation: particle-animation 2s ease-in-out infinite 0.7s;
        }
        
        .secure-particles .particle:nth-child(6) {
          top: 50%;
          right: 0;
          animation: particle-animation 2s ease-in-out infinite 0.1s;
        }
        
        .login-loading-text {
          font-size: 16px;
          font-weight: 500;
          color: white;
          text-align: center;
          position: relative;
          max-width: 200px;
        }
        
        .login-loading-text:after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, 
            rgba(79, 70, 229, 0) 0%, 
            rgba(79, 70, 229, 1) 50%,
            rgba(79, 70, 229, 0) 100%);
          animation: line-animation 2s infinite;
        }
        
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            transform: scale(0.8);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.7;
          }
        }
        
        @keyframes pulse-icon {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.15);
          }
        }
        
        @keyframes particle-animation {
          0% {
            transform: translateY(0) translateX(0);
            opacity: 0;
          }
          25% {
            opacity: 1;
          }
          75% {
            opacity: 1;
          }
          100% {
            transform: translateY(-20px) translateX(20px);
            opacity: 0;
          }
        }
        
        @keyframes line-animation {
          0%, 100% {
            width: 20%;
            left: 40%;
          }
          50% {
            width: 80%;
            left: 10%;
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingLogin;
